export const useStoreApp = defineStore('StoreApp', {
    state: () => ({
        mounted: false,
        blurred: false,
        muted: true,
    }),
    actions: {
        async initApp() {
            return Promise.all([useStoreAuth().initCurrentUser()]);
        },
        // We don't need to get current user on app mount as this is handled by auth.js middleware
        mountApp() {
            if (this.mounted) return true;
            this.mounted = true;
            console.log('App Mounted!');
            useStoreCookies().initCookies();
            useStoreThreadsUnread().startUnreadThreadPoller();
        },
        blurApp() {
            if (this.blurred) return true;
            this.blurred = true;
            console.log('App Blurred!');
            useStoreThreadsUnread().stopUnreadThreadPoller();
        },
        focusApp() {
            if (!this.blurred) return true;
            this.blurred = false;
            console.log('App Focused!');
            useStoreAuth().getCurrentUser().finally(); // Kicks off unread poller if user is signed in
        },
        muteApp() {
            this.muted = true;
            console.log('App Muted!');
        },
        unmuteApp() {
            this.muted = false;
            console.log('App Unmuted!');
        },
    },
});
